import React from "react";
import { motion } from "framer-motion";
import { FaBook, FaCalendarAlt, FaImages } from "react-icons/fa";

const AdditionalSections = () => {
  return (
    <section className="bg-gray-100 py-12 px-6 md:px-16">
      {/* Programs Offered Section */}
      <div className="text-center mb-12">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-white rounded-lg shadow-lg p-8 hover:shadow-2xl transition"
        >
          <FaBook className="text-yellow-500 text-6xl mx-auto mb-4" />
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Programs Offered
          </h2>
          <p className="text-lg text-gray-700 mb-6">
            Discover our Pre-primary, Primary, and Junior Secondary programs designed for excellence.
          </p>
          <a
            href="/admissions"
            className="bg-yellow-500 text-blue-900 px-8 py-3 rounded-full font-medium text-lg shadow-lg hover:bg-yellow-600 transition"
          >
            Learn More
          </a>
        </motion.div>
      </div>

      {/* Events or Announcements Section */}
      <div className="text-center mt-16 mb-12">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="bg-white rounded-lg shadow-lg p-8 hover:shadow-2xl transition"
        >
          <FaCalendarAlt className="text-yellow-500 text-6xl mx-auto mb-4" />
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Events & Announcements
          </h2>
          <p className="text-lg text-gray-700 mb-6">
            Stay updated with the latest happenings and important announcements.
          </p>
          <a
            href="/user-events"
            className="bg-yellow-500 text-blue-900 px-8 py-3 rounded-full font-medium text-lg shadow-lg hover:bg-yellow-600 transition"
          >
            View Events
          </a>
        </motion.div>
      </div>

      {/* Gallery Section */}
      <div className="text-center mt-16">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="bg-white rounded-lg shadow-lg p-8 hover:shadow-2xl transition"
        >
          <FaImages className="text-yellow-500 text-6xl mx-auto mb-4" />
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Gallery
          </h2>
          <p className="text-lg text-gray-700 mb-6">
            Explore moments from our vibrant school community.
          </p>
          <a
            href="/media"
            className="bg-yellow-500 text-blue-900 px-8 py-3 rounded-full font-medium text-lg shadow-lg hover:bg-yellow-600 transition"
          >
            Visit Gallery
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default AdditionalSections;
